import './terrain-control.styl'

class TerrainControl {
  constructor(map) {
    this._container = null
    this.map = map
    this.button = null
    this.isActive = false
  }

  onAdd() {
    this._container = document.createElement('div')
    this._container.className = `maplibregl-ctrl maplibregl-ctrl-group maplibregl-ctrl-terrain`

    const button = document.createElement('button')
    this.button = button
    button.type = 'button'
    button.title = 'Enable terrain'
    button.onclick = () => this.toggleTerrain()

    this.map.on('load', () => {
      this.map.addSource('terrain', {
        type: 'raster-dem',
        url: `https://api.maptiler.com/tiles/terrain-rgb-v2/tiles.json?key=${import.meta.env.VITE_MAPTILER_KEY}`,
      })
    })

    this._container.appendChild(button)

    return this._container
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container)
  }

  toggleTerrain() {
    this.isActive = !this.isActive
    if (this.isActive) {
      this.map.setPitch(45)
      this.map.setTerrain({ source: 'terrain', exaggeration: 1.5 })
      this._container.classList.add('maplibregl-ctrl-terrain--active')
      this.button.title = 'Disable terrain'
    }
    else {
      this.map.setPitch(0)
      this.map.setTerrain(null)
      this._container.classList.remove('maplibregl-ctrl-terrain--active')
      this.button.title = 'Enable terrain'
    }
  }
}

export default TerrainControl
